export { default } from './ImageViewer';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/ImageViewer/index.js